export type CentralReprocessamentoStatus =
  | 'CRIADO'
  | 'AGUARDANDO_SOLICITACAO'
  | 'AGUARDANDO_APROVACAO'
  | 'AGUARDANDO_EXECUCAO'
  | 'EM_ANDAMENTO'
  | 'FINALIZADO'
  | 'ERRO';
export type CentralReprocessamentoStatusNome =
  | 'Criado'
  | 'Solicitando'
  | 'Aguardando aprovação'
  | 'Aguardando execução'
  | 'Em andamento'
  | 'Finalizado'
  | 'Falhou';

export const CENTRAL_REPROCESSAMENTO_STATUS_NOMES: Record<
  CentralReprocessamentoStatus,
  CentralReprocessamentoStatusNome
> = {
  CRIADO: 'Criado',
  AGUARDANDO_SOLICITACAO: 'Solicitando',
  AGUARDANDO_APROVACAO: 'Aguardando aprovação',
  AGUARDANDO_EXECUCAO: 'Aguardando execução',
  EM_ANDAMENTO: 'Em andamento',
  FINALIZADO: 'Finalizado',
  ERRO: 'Falhou',
};
